<template>
  <TEditor :apiKey="apiKey" :placeholder="placeholder" :value="value" @keyup="inputChange" :init="customInit" />
</template>

<script lang="ts" setup>
import { default as TEditor } from '@tinymce/tinymce-vue';
import { computed, nextTick, ref, toRef, watch } from 'vue';
import { mainStore } from '~/pinia-store/main';

const props = defineProps({
  init: {
    type: Object,
    default: {},
  },
  value: {
    type: String,
    default: '',
  },
  apiKey: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: 'Body',
  },
});

const apiKey = toRef(props, 'apiKey');
const init = toRef(props, 'init');
const placeholder = toRef(props, 'placeholder');
const value = toRef(props, 'value');

const emits = defineEmits(['input', 'update:value']);

const inputChange = (val: string) => {
  emits('input', val);
  emits('update:value', val);
};

const ready = ref(true);

const dark = computed(() => {
  const { dark } = mainStore()
  return dark.value
});

watch(dark, () => {
  ready.value = false;
  nextTick(() => {
    ready.value = true;
  });
});

const customInit = computed(() => {
  return {
    ...init.value,
    content_css: dark.value ? 'dark' : '',
    content_style: dark.value
      ? 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px; color: white; background-color: transparent }' +
        'body::before { color: #878094 !important }'
      : '',
  };
});
</script>

<style lang="sass" scoped></style>
